export default __webpack_public_path__ + "static/media/svea_w.9c7a9c70.svg";